export default {
  region: {
    RegionName: 'Region Name',
    Region: 'Region',
    RegionId: 'RegionId',
    ParentId: 'ParentId',
    ParentName: 'ParentName',
    Remark: 'Remark',
    NewRegion: 'New Region',
    ModifyAreaInformation: 'Modify Area Information',
    Status: 'Status',
    No: 'No',
    Code: 'Code',
    Edit: 'Edit'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en/cmc/region.js